export interface Product {
  id: string;
  name: string;
  nameFr: string;
  description: string;
  descriptionFr: string;
  price: number;
  category: string;
  subcategory: string;
  image: string;
  stock: number;
  rating: number;
  reviews: number;
  specifications?: Record<string, string>;
  features?: string[];
  featuresFr?: string[];
  isNew?: boolean;
  isFeatured?: boolean;
  discount?: number;
}

export const products: Product[] = [
  // Building Materials
  {
    id: '1',
    name: 'Premium Cement 50kg Bag',
    nameFr: 'Ciment Premium Sac de 50kg',
    description: 'High-quality Portland cement for all construction projects. Excellent strength and durability.',
    descriptionFr: 'Ciment Portland de haute qualité pour tous les projets de construction. Excellente résistance et durabilité.',
    price: 8500,
    category: 'building-materials',
    subcategory: 'cement',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 150,
    rating: 4.8,
    reviews: 45,
    specifications: {
      'Weight': '50kg',
      'Type': 'Portland Cement',
      'Strength': '42.5R',
      'Setting Time': '2-3 hours'
    },
    features: [
      'High compressive strength',
      'Fast setting time',
      'Suitable for all weather conditions',
      'Certified quality'
    ],
    featuresFr: [
      'Haute résistance à la compression',
      'Temps de prise rapide',
      'Adapté à toutes les conditions météorologiques',
      'Qualité certifiée'
    ],
    isFeatured: true
  },
  {
    id: '2',
    name: 'Reinforced Steel Bars 12mm',
    nameFr: 'Barres d\'acier armé 12mm',
    description: 'High-tensile steel reinforcement bars for concrete structures. Available in various lengths.',
    descriptionFr: 'Barres d\'armature en acier à haute résistance pour structures en béton. Disponible en différentes longueurs.',
    price: 45000,
    category: 'building-materials',
    subcategory: 'steel',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 80,
    rating: 4.9,
    reviews: 32,
    specifications: {
      'Diameter': '12mm',
      'Length': '6m',
      'Grade': 'Fe 500',
      'Weight per meter': '0.89kg'
    },
    features: [
      'High tensile strength',
      'Corrosion resistant',
      'Perfect for concrete reinforcement',
      'Meets international standards'
    ],
    featuresFr: [
      'Haute résistance à la traction',
      'Résistant à la corrosion',
      'Parfait pour l\'armature du béton',
      'Conforme aux normes internationales'
    ]
  },
  {
    id: '3',
    name: 'Concrete Blocks 20cm',
    nameFr: 'Blocs de béton 20cm',
    description: 'Standard concrete blocks for wall construction. Durable and easy to install.',
    descriptionFr: 'Blocs de béton standard pour la construction de murs. Durables et faciles à installer.',
    price: 350,
    category: 'building-materials',
    subcategory: 'blocks',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 500,
    rating: 4.6,
    reviews: 28,
    specifications: {
      'Size': '20cm x 20cm x 40cm',
      'Weight': '18kg',
      'Compressive Strength': '7N/mm²',
      'Quantity per pallet': '120 units'
    },
    features: [
      'Standard size for easy handling',
      'High compressive strength',
      'Thermal insulation properties',
      'Fire resistant'
    ],
    featuresFr: [
      'Taille standard pour une manipulation facile',
      'Haute résistance à la compression',
      'Propriétés d\'isolation thermique',
      'Résistant au feu'
    ]
  },
  {
    id: '13',
    name: 'Sand 1 Ton Bag',
    nameFr: 'Sable Sac de 1 tonne',
    description: 'Fine construction sand for concrete and mortar mixing.',
    descriptionFr: 'Sable fin de construction pour mélange de béton et mortier.',
    price: 25000,
    category: 'building-materials',
    subcategory: 'aggregates',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 30,
    rating: 4.5,
    reviews: 15,
    specifications: {
      'Weight': '1 tonne',
      'Type': 'Fine Sand',
      'Grain Size': '0.1-2mm',
      'Moisture': '<3%'
    },
    features: [
      'Clean and washed',
      'Consistent grain size',
      'Ideal for concrete',
      'Bulk delivery available'
    ],
    featuresFr: [
      'Propre et lavé',
      'Taille de grain uniforme',
      'Idéal pour le béton',
      'Livraison en vrac disponible'
    ]
  },
  {
    id: '14',
    name: 'Gravel 20mm',
    nameFr: 'Gravier 20mm',
    description: 'Coarse aggregate for concrete and road construction.',
    descriptionFr: 'Granulat grossier pour béton et construction routière.',
    price: 30000,
    category: 'building-materials',
    subcategory: 'aggregates',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 25,
    rating: 4.4,
    reviews: 12,
    specifications: {
      'Size': '20mm',
      'Weight': '1 tonne',
      'Type': 'Crushed Stone',
      'Density': '1.6 t/m³'
    },
    features: [
      'High strength aggregate',
      'Well graded',
      'Clean and durable',
      'Suitable for heavy loads'
    ],
    featuresFr: [
      'Granulat haute résistance',
      'Bien calibré',
      'Propre et durable',
      'Adapté aux charges lourdes'
    ]
  },
  {
    id: '15',
    name: 'Steel Beams I-Beam 200mm',
    nameFr: 'Poutres en acier I-Beam 200mm',
    description: 'Structural steel I-beams for building frameworks.',
    descriptionFr: 'Poutres en acier structural I-Beam pour charpentes de bâtiment.',
    price: 180000,
    category: 'building-materials',
    subcategory: 'steel',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 15,
    rating: 4.7,
    reviews: 8,
    specifications: {
      'Height': '200mm',
      'Length': '6m',
      'Weight': '25.3kg/m',
      'Grade': 'S235JR'
    },
    features: [
      'Structural grade steel',
      'High load capacity',
      'Easy to weld',
      'Corrosion resistant coating'
    ],
    featuresFr: [
      'Acier de qualité structurale',
      'Haute capacité de charge',
      'Facile à souder',
      'Revêtement anti-corrosion'
    ]
  },

  // Tools & Equipment
  {
    id: '4',
    name: 'Professional Hammer Drill',
    nameFr: 'Perceuse à percussion professionnelle',
    description: 'Heavy-duty hammer drill for concrete and masonry work. Variable speed control.',
    descriptionFr: 'Perceuse à percussion robuste pour travaux de béton et maçonnerie. Contrôle de vitesse variable.',
    price: 85000,
    category: 'tools-equipment',
    subcategory: 'power-tools',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 25,
    rating: 4.7,
    reviews: 18,
    specifications: {
      'Power': '800W',
      'Chuck Size': '13mm',
      'Impact Rate': '0-4000 BPM',
      'Weight': '2.8kg'
    },
    features: [
      'Variable speed control',
      'Anti-vibration handle',
      'Quick-change chuck',
      'Includes carrying case'
    ],
    featuresFr: [
      'Contrôle de vitesse variable',
      'Poignée anti-vibration',
      'Mandrin à changement rapide',
      'Inclut un étui de transport'
    ],
    isNew: true
  },
  {
    id: '5',
    name: 'Safety Hard Hat',
    nameFr: 'Casque de sécurité',
    description: 'ANSI-certified safety helmet for construction sites. Adjustable headband and ventilation.',
    descriptionFr: 'Casque de sécurité certifié ANSI pour chantiers de construction. Bandeau ajustable et ventilation.',
    price: 12000,
    category: 'tools-equipment',
    subcategory: 'safety',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 100,
    rating: 4.5,
    reviews: 67,
    specifications: {
      'Standard': 'ANSI Z89.1',
      'Material': 'High-density polyethylene',
      'Color': 'Yellow',
      'Adjustable': 'Yes'
    },
    features: [
      'ANSI certified',
      'Adjustable headband',
      'Ventilation holes',
      'UV resistant'
    ],
    featuresFr: [
      'Certifié ANSI',
      'Bandeau ajustable',
      'Trous de ventilation',
      'Résistant aux UV'
    ]
  },
  {
    id: '6',
    name: 'Measuring Tape 5m',
    nameFr: 'Mètre ruban 5m',
    description: 'Professional measuring tape with magnetic tip and lock mechanism.',
    descriptionFr: 'Mètre ruban professionnel avec pointe magnétique et mécanisme de verrouillage.',
    price: 3500,
    category: 'tools-equipment',
    subcategory: 'hand-tools',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 200,
    rating: 4.4,
    reviews: 89,
    specifications: {
      'Length': '5 meters',
      'Width': '25mm',
      'Material': 'Steel',
      'Magnetic Tip': 'Yes'
    },
    features: [
      'Magnetic tip for metal surfaces',
      'Lock mechanism',
      'Clear markings',
      'Durable case'
    ],
    featuresFr: [
      'Pointe magnétique pour surfaces métalliques',
      'Mécanisme de verrouillage',
      'Marquages clairs',
      'Boîtier durable'
    ]
  },
  {
    id: '16',
    name: 'Circular Saw 7-1/4"',
    nameFr: 'Scie circulaire 7-1/4"',
    description: 'Professional circular saw for cutting wood, metal, and plastic.',
    descriptionFr: 'Scie circulaire professionnelle pour couper bois, métal et plastique.',
    price: 95000,
    category: 'tools-equipment',
    subcategory: 'power-tools',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 18,
    rating: 4.6,
    reviews: 22,
    specifications: {
      'Blade Size': '7-1/4"',
      'Power': '1200W',
      'RPM': '5000',
      'Weight': '3.2kg'
    },
    features: [
      'Laser guide system',
      'Electric brake',
      'Dust extraction port',
      'Bevel cutting capability'
    ],
    featuresFr: [
      'Système de guidage laser',
      'Frein électrique',
      'Port d\'extraction de poussière',
      'Capacité de coupe en biseau'
    ]
  },
  {
    id: '17',
    name: 'Safety Glasses',
    nameFr: 'Lunettes de sécurité',
    description: 'Impact-resistant safety glasses with UV protection.',
    descriptionFr: 'Lunettes de sécurité résistantes aux impacts avec protection UV.',
    price: 2500,
    category: 'tools-equipment',
    subcategory: 'safety',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 150,
    rating: 4.3,
    reviews: 45,
    specifications: {
      'Standard': 'ANSI Z87.1',
      'Material': 'Polycarbonate',
      'UV Protection': '99.9%',
      'Color': 'Clear'
    },
    features: [
      'Impact resistant',
      'UV protection',
      'Anti-fog coating',
      'Comfortable fit'
    ],
    featuresFr: [
      'Résistant aux impacts',
      'Protection UV',
      'Revêtement anti-buée',
      'Ajustement confortable'
    ]
  },
  {
    id: '18',
    name: 'Level 60cm',
    nameFr: 'Niveau 60cm',
    description: 'Professional spirit level for accurate measurements.',
    descriptionFr: 'Niveau à bulle professionnel pour mesures précises.',
    price: 4500,
    category: 'tools-equipment',
    subcategory: 'measuring',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 80,
    rating: 4.5,
    reviews: 33,
    specifications: {
      'Length': '60cm',
      'Accuracy': '0.5mm/m',
      'Material': 'Aluminum',
      'Vials': '3 (horizontal, vertical, 45°)'
    },
    features: [
      'High accuracy',
      'Durable aluminum body',
      'Three vials',
      'Magnetic base'
    ],
    featuresFr: [
      'Haute précision',
      'Corps en aluminium durable',
      'Trois fioles',
      'Base magnétique'
    ]
  },
  {
    id: '19',
    name: 'Cordless Drill 18V',
    nameFr: 'Perceuse sans fil 18V',
    description: 'High-performance cordless drill with lithium battery.',
    descriptionFr: 'Perceuse sans fil haute performance avec batterie lithium.',
    price: 75000,
    category: 'tools-equipment',
    subcategory: 'power-tools',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 30,
    rating: 4.8,
    reviews: 41,
    specifications: {
      'Voltage': '18V',
      'Torque': '60Nm',
      'Chuck Size': '13mm',
      'Battery': '2.0Ah Li-ion'
    },
    features: [
      'Brushless motor',
      'LED work light',
      'Quick-change chuck',
      '2-speed transmission'
    ],
    featuresFr: [
      'Moteur sans balais',
      'Lampe de travail LED',
      'Mandrin à changement rapide',
      'Transmission 2 vitesses'
    ],
    isNew: true
  },

  // Plumbing & Electrical
  {
    id: '7',
    name: 'PVC Pipes 110mm',
    nameFr: 'Tuyaux PVC 110mm',
    description: 'Heavy-duty PVC pipes for drainage and sewer systems. UV resistant.',
    descriptionFr: 'Tuyaux PVC robustes pour systèmes de drainage et d\'égout. Résistant aux UV.',
    price: 8500,
    category: 'plumbing-electrical',
    subcategory: 'pipes',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 75,
    rating: 4.6,
    reviews: 23,
    specifications: {
      'Diameter': '110mm',
      'Length': '3m',
      'Class': 'SN8',
      'Color': 'Orange'
    },
    features: [
      'UV resistant',
      'Chemical resistant',
      'Easy to install',
      'Long service life'
    ],
    featuresFr: [
      'Résistant aux UV',
      'Résistant aux produits chimiques',
      'Facile à installer',
      'Longue durée de vie'
    ]
  },
  {
    id: '8',
    name: 'Electrical Cable 2.5mm²',
    nameFr: 'Câble électrique 2.5mm²',
    description: 'Copper electrical cable for residential and commercial wiring.',
    descriptionFr: 'Câble électrique en cuivre pour câblage résidentiel et commercial.',
    price: 12000,
    category: 'plumbing-electrical',
    subcategory: 'electrical',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 120,
    rating: 4.8,
    reviews: 41,
    specifications: {
      'Conductor': '2.5mm²',
      'Cores': '3',
      'Voltage': '450/750V',
      'Length': '100m'
    },
    features: [
      'Pure copper conductor',
      'PVC insulation',
      'Fire resistant',
      'IEC certified'
    ],
    featuresFr: [
      'Conducteur en cuivre pur',
      'Isolation PVC',
      'Résistant au feu',
      'Certifié IEC'
    ]
  },
  {
    id: '20',
    name: 'Copper Pipes 15mm',
    nameFr: 'Tuyaux en cuivre 15mm',
    description: 'High-quality copper pipes for water supply systems.',
    descriptionFr: 'Tuyaux en cuivre de haute qualité pour systèmes d\'alimentation en eau.',
    price: 15000,
    category: 'plumbing-electrical',
    subcategory: 'pipes',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 60,
    rating: 4.7,
    reviews: 28,
    specifications: {
      'Diameter': '15mm',
      'Length': '3m',
      'Material': 'Copper',
      'Thickness': '1mm'
    },
    features: [
      'Corrosion resistant',
      'Long service life',
      'Easy to solder',
      'Bacteria resistant'
    ],
    featuresFr: [
      'Résistant à la corrosion',
      'Longue durée de vie',
      'Facile à souder',
      'Résistant aux bactéries'
    ]
  },
  {
    id: '21',
    name: 'Circuit Breaker 32A',
    nameFr: 'Disjoncteur 32A',
    description: 'Single-pole circuit breaker for electrical protection.',
    descriptionFr: 'Disjoncteur unipolaire pour protection électrique.',
    price: 8500,
    category: 'plumbing-electrical',
    subcategory: 'electrical',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 90,
    rating: 4.6,
    reviews: 35,
    specifications: {
      'Current': '32A',
      'Type': 'Single-pole',
      'Breaking Capacity': '6kA',
      'Standard': 'IEC 60898'
    },
    features: [
      'Thermal-magnetic protection',
      'Easy installation',
      'Compact design',
      'High breaking capacity'
    ],
    featuresFr: [
      'Protection thermo-magnétique',
      'Installation facile',
      'Design compact',
      'Haute capacité de coupure'
    ]
  },
  {
    id: '22',
    name: 'PVC Fittings Kit',
    nameFr: 'Kit de raccords PVC',
    description: 'Complete set of PVC fittings for plumbing installations.',
    descriptionFr: 'Ensemble complet de raccords PVC pour installations de plomberie.',
    price: 18000,
    category: 'plumbing-electrical',
    subcategory: 'fittings',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 45,
    rating: 4.5,
    reviews: 19,
    specifications: {
      'Size Range': '20-110mm',
      'Pieces': '50',
      'Material': 'PVC',
      'Pressure': 'PN10'
    },
    features: [
      'Complete fitting set',
      'Chemical resistant',
      'Easy to assemble',
      'Leak-proof connections'
    ],
    featuresFr: [
      'Ensemble de raccords complet',
      'Résistant aux produits chimiques',
      'Facile à assembler',
      'Connexions étanches'
    ]
  },
  {
    id: '23',
    name: 'LED Panel Light 60x60cm',
    nameFr: 'Panneau LED 60x60cm',
    description: 'Energy-efficient LED panel for commercial lighting.',
    descriptionFr: 'Panneau LED économe en énergie pour éclairage commercial.',
    price: 25000,
    category: 'plumbing-electrical',
    subcategory: 'electrical',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 35,
    rating: 4.8,
    reviews: 26,
    specifications: {
      'Size': '60x60cm',
      'Power': '40W',
      'Lumens': '4000lm',
      'Color Temperature': '4000K'
    },
    features: [
      'Energy efficient',
      'Long lifespan',
      'Dimmable option',
      'Easy installation'
    ],
    featuresFr: [
      'Économe en énergie',
      'Longue durée de vie',
      'Option d\'atténuation',
      'Installation facile'
    ],
    isFeatured: true
  },

  // Finishing Materials
  {
    id: '9',
    name: 'Ceramic Tiles 30x30cm',
    nameFr: 'Carreaux céramiques 30x30cm',
    description: 'High-quality ceramic floor tiles. Available in various colors and finishes.',
    descriptionFr: 'Carreaux de sol céramiques de haute qualité. Disponible en différentes couleurs et finitions.',
    price: 2500,
    category: 'finishing-materials',
    subcategory: 'tiles',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 300,
    rating: 4.7,
    reviews: 56,
    specifications: {
      'Size': '30cm x 30cm',
      'Thickness': '8mm',
      'Finish': 'Glazed',
      'PEI Rating': 'III'
    },
    features: [
      'Scratch resistant',
      'Stain resistant',
      'Easy to clean',
      'Suitable for floors and walls'
    ],
    featuresFr: [
      'Résistant aux rayures',
      'Résistant aux taches',
      'Facile à nettoyer',
      'Adapté aux sols et murs'
    ],
    isFeatured: true
  },
  {
    id: '10',
    name: 'Interior Paint 20L',
    nameFr: 'Peinture intérieure 20L',
    description: 'Premium interior wall paint. Low VOC, washable finish.',
    descriptionFr: 'Peinture murale intérieure premium. Faible teneur en COV, finition lavable.',
    price: 45000,
    category: 'finishing-materials',
    subcategory: 'paint',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 40,
    rating: 4.5,
    reviews: 34,
    specifications: {
      'Volume': '20 liters',
      'Coverage': '12m²/L',
      'Drying Time': '2 hours',
      'VOC': 'Low'
    },
    features: [
      'Low VOC content',
      'Washable finish',
      'Mildew resistant',
      'Easy application'
    ],
    featuresFr: [
      'Faible teneur en COV',
      'Finition lavable',
      'Résistant à la moisissure',
      'Application facile'
    ]
  },
  {
    id: '24',
    name: 'Vinyl Flooring 4m²',
    nameFr: 'Revêtement de sol vinyle 4m²',
    description: 'Waterproof vinyl flooring planks with realistic wood appearance.',
    descriptionFr: 'Lames de revêtement de sol vinyle imperméables avec apparence bois réaliste.',
    price: 35000,
    category: 'finishing-materials',
    subcategory: 'flooring',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 25,
    rating: 4.6,
    reviews: 31,
    specifications: {
      'Coverage': '4m²',
      'Thickness': '4mm',
      'Plank Size': '120x20cm',
      'Wear Layer': '0.3mm'
    },
    features: [
      'Waterproof',
      'Easy installation',
      'Realistic wood look',
      'Scratch resistant'
    ],
    featuresFr: [
      'Imperméable',
      'Installation facile',
      'Aspect bois réaliste',
      'Résistant aux rayures'
    ]
  },
  {
    id: '25',
    name: 'Ceiling Tiles 60x60cm',
    nameFr: 'Plaques de plafond 60x60cm',
    description: 'Acoustic ceiling tiles for noise reduction and thermal insulation.',
    descriptionFr: 'Plaques de plafond acoustiques pour réduction du bruit et isolation thermique.',
    price: 1800,
    category: 'finishing-materials',
    subcategory: 'ceiling',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 120,
    rating: 4.4,
    reviews: 23,
    specifications: {
      'Size': '60x60cm',
      'Thickness': '15mm',
      'NRC Rating': '0.6',
      'Material': 'Mineral fiber'
    },
    features: [
      'Acoustic properties',
      'Fire resistant',
      'Easy to install',
      'Thermal insulation'
    ],
    featuresFr: [
      'Propriétés acoustiques',
      'Résistant au feu',
      'Facile à installer',
      'Isolation thermique'
    ]
  },
  {
    id: '26',
    name: 'Exterior Paint 20L',
    nameFr: 'Peinture extérieure 20L',
    description: 'Weather-resistant exterior paint for walls and facades.',
    descriptionFr: 'Peinture extérieure résistante aux intempéries pour murs et façades.',
    price: 52000,
    category: 'finishing-materials',
    subcategory: 'paint',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 30,
    rating: 4.7,
    reviews: 28,
    specifications: {
      'Volume': '20 liters',
      'Coverage': '10m²/L',
      'Drying Time': '4 hours',
      'UV Resistance': 'High'
    },
    features: [
      'Weather resistant',
      'UV protection',
      'Mold resistant',
      'Long lasting finish'
    ],
    featuresFr: [
      'Résistant aux intempéries',
      'Protection UV',
      'Résistant aux moisissures',
      'Finition durable'
    ]
  },
  {
    id: '27',
    name: 'Marble Tiles 60x60cm',
    nameFr: 'Carreaux de marbre 60x60cm',
    description: 'Premium marble tiles for luxury interior finishes.',
    descriptionFr: 'Carreaux de marbre premium pour finitions intérieures de luxe.',
    price: 85000,
    category: 'finishing-materials',
    subcategory: 'tiles',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 15,
    rating: 4.9,
    reviews: 12,
    specifications: {
      'Size': '60x60cm',
      'Thickness': '12mm',
      'Material': 'Natural Marble',
      'Finish': 'Polished'
    },
    features: [
      'Natural stone',
      'Unique patterns',
      'High durability',
      'Luxury finish'
    ],
    featuresFr: [
      'Pierre naturelle',
      'Motifs uniques',
      'Haute durabilité',
      'Finition de luxe'
    ],
    isNew: true
  },

  // Hardware & Fasteners
  {
    id: '11',
    name: 'Screws Assortment Pack',
    nameFr: 'Lot de vis assorties',
    description: 'Mixed assortment of wood and metal screws. Various sizes included.',
    descriptionFr: 'Assortiment mixte de vis pour bois et métal. Différentes tailles incluses.',
    price: 8500,
    category: 'hardware-fasteners',
    subcategory: 'screws',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 150,
    rating: 4.3,
    reviews: 78,
    specifications: {
      'Pack Size': '500 pieces',
      'Materials': 'Steel, Brass',
      'Sizes': '3mm to 8mm',
      'Types': 'Wood, Metal, Drywall'
    },
    features: [
      'Mixed sizes for versatility',
      'High-quality steel',
      'Corrosion resistant',
      'Easy to use'
    ],
    featuresFr: [
      'Tailles mixtes pour la polyvalence',
      'Acier de haute qualité',
      'Résistant à la corrosion',
      'Facile à utiliser'
    ]
  },
  {
    id: '12',
    name: 'Door Hinges Set',
    nameFr: 'Lot de charnières de porte',
    description: 'Heavy-duty door hinges for interior and exterior doors.',
    descriptionFr: 'Charnières de porte robustes pour portes intérieures et extérieures.',
    price: 3500,
    category: 'hardware-fasteners',
    subcategory: 'hinges',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 200,
    rating: 4.6,
    reviews: 29,
    specifications: {
      'Size': '4 inches',
      'Material': 'Steel',
      'Finish': 'Zinc plated',
      'Pack': '2 hinges'
    },
    features: [
      'Heavy-duty construction',
      'Smooth operation',
      'Easy installation',
      'Durable finish'
    ],
    featuresFr: [
      'Construction robuste',
      'Fonctionnement fluide',
      'Installation facile',
      'Finition durable'
    ]
  },
  {
    id: '28',
    name: 'Nails Assortment 1kg',
    nameFr: 'Assortiment de clous 1kg',
    description: 'Mixed assortment of construction nails in various sizes.',
    descriptionFr: 'Assortiment mixte de clous de construction en différentes tailles.',
    price: 4500,
    category: 'hardware-fasteners',
    subcategory: 'nails',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 80,
    rating: 4.2,
    reviews: 45,
    specifications: {
      'Weight': '1kg',
      'Material': 'Steel',
      'Sizes': '20mm to 100mm',
      'Types': 'Common, Finishing, Roofing'
    },
    features: [
      'Galvanized finish',
      'Various sizes',
      'High tensile strength',
      'Rust resistant'
    ],
    featuresFr: [
      'Finition galvanisée',
      'Diverses tailles',
      'Haute résistance à la traction',
      'Résistant à la rouille'
    ]
  },
  {
    id: '29',
    name: 'Door Lock Set',
    nameFr: 'Serrure de porte',
    description: 'High-security door lock with key and installation hardware.',
    descriptionFr: 'Serrure de porte haute sécurité avec clé et quincaillerie d\'installation.',
    price: 15000,
    category: 'hardware-fasteners',
    subcategory: 'locks',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 40,
    rating: 4.7,
    reviews: 33,
    specifications: {
      'Type': 'Cylinder Lock',
      'Material': 'Brass',
      'Security': '5-pin tumbler',
      'Keys': '2 included'
    },
    features: [
      'High security',
      'Anti-pick design',
      'Easy installation',
      'Durable construction'
    ],
    featuresFr: [
      'Haute sécurité',
      'Design anti-crochetage',
      'Installation facile',
      'Construction durable'
    ]
  },
  {
    id: '30',
    name: 'Anchor Bolts M12',
    nameFr: 'Boulons d\'ancrage M12',
    description: 'Heavy-duty anchor bolts for concrete and masonry anchoring.',
    descriptionFr: 'Boulons d\'ancrage robustes pour ancrage béton et maçonnerie.',
    price: 8500,
    category: 'hardware-fasteners',
    subcategory: 'screws',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=500&auto=format&fit=crop&q=60',
    stock: 60,
    rating: 4.5,
    reviews: 27,
    specifications: {
      'Size': 'M12',
      'Length': '100mm',
      'Material': 'Stainless Steel',
      'Pack': '10 pieces'
    },
    features: [
      'Stainless steel',
      'High load capacity',
      'Corrosion resistant',
      'Easy installation'
    ],
    featuresFr: [
      'Acier inoxydable',
      'Haute capacité de charge',
      'Résistant à la corrosion',
      'Installation facile'
    ]
  }
];

export const categories = [
  {
    id: 'tools-equipment',
    name: 'Tools & Equipment',
    nameFr: 'Outils et équipements',
    description: 'Professional tools and equipment',
    descriptionFr: 'Outils professionnels et équipements',
    icon: '🔧',
    subcategories: ['power-tools', 'hand-tools', 'safety', 'measuring']
  },
  {
    id: 'utility-supplies',
    name: 'Utilities & Supplies',
    nameFr: 'Utilitaires & fournitures',
    description: 'Consumables and utility items for worksites',
    descriptionFr: 'Consommables et utilitaires pour chantiers',
    icon: '🧰',
    subcategories: ['consumables', 'adhesives', 'cleaning', 'storage']
  },
  {
    id: 'safety-gear',
    name: 'Safety Gear',
    nameFr: 'Équipements de sécurité',
    description: 'PPE and safety equipment',
    descriptionFr: 'EPI et équipements de sécurité',
    icon: '🦺',
    subcategories: ['helmets', 'gloves', 'boots', 'glasses']
  }
];

// Only expose products that belong to supported categories for the current catalog scope
export const allowedCategoryIds = ['tools-equipment', 'utility-supplies', 'safety-gear'] as const;
type AllowedCategory = typeof allowedCategoryIds[number];

const isAllowedCategory = (category: string): category is AllowedCategory => {
  return (allowedCategoryIds as readonly string[]).includes(category);
};

export const getProductsByCategory = (category: string) => {
  if (!isAllowedCategory(category)) return [];
  return products.filter(product => product.category === category && isAllowedCategory(product.category));
};

export const getFeaturedProducts = () => {
  return products.filter(product => product.isFeatured && isAllowedCategory(product.category));
};

export const getNewProducts = () => {
  return products.filter(product => product.isNew && isAllowedCategory(product.category));
};

export const searchProducts = (query: string) => {
  const lowercaseQuery = query.toLowerCase();
  return products.filter(product =>
    isAllowedCategory(product.category) && (
      product.name.toLowerCase().includes(lowercaseQuery) ||
      product.nameFr.toLowerCase().includes(lowercaseQuery) ||
      product.description.toLowerCase().includes(lowercaseQuery) ||
      product.descriptionFr.toLowerCase().includes(lowercaseQuery) ||
      product.category.toLowerCase().includes(lowercaseQuery)
    )
  );
}; 